import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';

export default function Skeleton({ isLoading = false, isError = false, rows = 10 }): ReactElement {
  return (
    <div className={clsx('card skeleton', { loading: isLoading, error: isError })}>
      <div className="card-header">
        <div className="skeleton-box" style={{ width: '40ch' }} />
      </div>
      <div className="card-body">
        <div className="skeleton-box" style={{ width: '30%' }} />
        <div className="skeleton-box" style={{ width: '30%' }} />
        <div className="skeleton-box" style={{ width: '30%' }} />
        <br />
        {Array.from({ length: rows }).map(() => (
          <>
            <div className="skeleton-box" style={{ width: '24%' }} />
            <div className="skeleton-box" style={{ width: '24%' }} />
            <div className="skeleton-box" style={{ width: '24%' }} />
            <div className="skeleton-box" style={{ width: '24%' }} />
          </>
        ))}
        <br />
        <div className="skeleton-box" style={{ width: '100%' }} />
      </div>
    </div>
  );
}
